import {
  IApiEpBillingPaymentProvider,
  IApiEpBillingProductPurchaseRes,
} from "@smp/api";
import { FC } from "react";

import { Cloudpayments } from "./cloudpayments";
import { ExternalWindow } from "./external_window";
import { Manual } from "./manual";
import { Paddle } from "./paddle";
import { Stub } from "./stub";
import { Yakassa } from "./yakassa";

export type IPaymentV2Props = {
  invoice: IApiEpBillingProductPurchaseRes;
  provider: IApiEpBillingPaymentProvider;
  onDecline: () => void;
  onSuccess?: () => void;
};

export const PaymentV2: FC<IPaymentV2Props> = ({
  invoice,
  provider,
  onDecline,
  onSuccess,
}) => {
  if (invoice.status === "complete") {
    return <Stub />;
  }

  const providerId = invoice.recurring_payment
    ? invoice.recurring_payment.provider_id
    : invoice.bill.payment_provider;

  if (providerId === "cloudpayments") {
    return (
      <Cloudpayments
        onDecline={onDecline}
        onSuccess={onSuccess}
        invoice={invoice}
        provider={provider}
      />
    );
  } else if (providerId === "paddle") {
    return (
      <Paddle onDecline={onDecline} onSuccess={onSuccess} invoice={invoice} />
    );
  } else if (providerId === "yakassa") {
    if (invoice.bill) {
      return (
        <Yakassa
          bill={invoice.bill}
          onDecline={onDecline}
          onSuccess={onSuccess}
        />
      );
    }
  } else if (
    providerId === "maib" ||
    providerId === "paypal" ||
    providerId === "qiwi"
  ) {
    return (
      <ExternalWindow
        invoice={invoice}
        provider={provider}
        onDecline={onDecline}
        onSuccess={onSuccess}
      />
    );
  } else if (providerId === "manual") {
    return <Manual />;
  }

  return null;
};
